(ns nl.mediquest.ui.html.breadcrumbs)

(defn- top-breadcrumb-link [{:keys [portaal-url]}]
  {:breadcrumb/url (or portaal-url "/")
   :breadcrumb/title "Start"
   :breadcrumb/icon :fa-home})

(def ^:private arrow-breadcrumb
  [:i.far.fa-arrow-right])

(defn- breadcrumb-view [{:breadcrumb/keys [url title icon class]}]
  [:a.last:font-semibold
   (when url
     {:href (if (fn? url) (url) url)
      :class ["hover:underline" "hover:underline-offset-4"]})
   (when icon
     [:i.far.mr-2 {:class (concat [icon] class)}])
   (if (fn? title)
     [title]
     title)])

(defn view [context breadcrumbs]
  [:div.text-primary.flex.flex-wrap.items-center.ml-3.gap-y-1.gap-x-2
   [breadcrumb-view (top-breadcrumb-link context)]
   (doall
    (map-indexed
     (fn [i breadcrumb]
       ^{:key (:breadcrumb/title breadcrumb i)}
       [:<>
        arrow-breadcrumb
        [breadcrumb-view breadcrumb]])
     breadcrumbs))])
